import { ViewController } from '@estee/elc-service';
import { observable, action, computed } from 'mobx';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { UserLocationRepository } from '~repositories/UserLocationRepository';
import { BopisFilterToggledUseCase } from '~use-cases/BopisUseCases/BopisFilterToggleUseCase';
import { BopisFiltersRepository } from '~repositories/BopisRepositories/BopisFiltersRepository';

export class BopisStoresFiltersViewController extends ViewController {
    @observable private filtersRepository: BopisFiltersRepository;
    @observable private userLocationRepository: UserLocationRepository;
    @observable private userZipCode: string;

    constructor() {
        super();
        this.filtersRepository = diContainer.get(serviceNames.bopisFiltersRepository);
        this.userLocationRepository = diContainer.get(serviceNames.userLocationRepository);
    }

    @action
    public updateUserZipCode = () => {
        this.userZipCode = this.userLocationRepository.userLocation.zipcode;
    };

    @action
    public onOpenNowClick = async () => {
        this.filtersRepository.toggleBooleanFilter('openNow');
        await new BopisFilterToggledUseCase().execute();
    };

    @action
    public onStoresWithAvailabilityClick = async () => {
        this.filtersRepository.toggleBooleanFilter('storesWithAvailability');
        await new BopisFilterToggledUseCase().execute();
    };

    @computed
    public get data() {
        return {
            booleanFilters: this.filtersRepository.booleanFilters,
            openNowEnabled: this.filtersRepository.openNowEnabled,
            userZipCode: this.userLocationRepository.userLocation.zipcode || this.userZipCode
        };
    }
}
